import { useRef } from "react";

/**
 * Interactive cursor spotlight — tracks the pointer over a card and exposes
 * its position via CSS custom properties (--mx / --my) on the element, so an
 * overlay can render a radial-gradient glow that follows the cursor.
 */
export function useCardSpotlight<T extends HTMLElement = HTMLDivElement>() {
  const ref = useRef<T>(null);

  const onMouseMove = (e: React.MouseEvent<T>) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    el.style.setProperty("--mx", `${e.clientX - rect.left}px`);
    el.style.setProperty("--my", `${e.clientY - rect.top}px`);
  };

  return { ref, onMouseMove };
}
